import { cast, types } from "mobx-state-tree";

import { UsersStorageModel } from "./UsersStorage";
import { Column, ColumnType } from "../../components/datatable/interfaces";
import { Option } from "../../components/datatable/interfaces";
import { Role } from "./Role";

const UsersSummaryModel = types.model({
  userRoleOptions: types.array(types.frozen<Option>()),
});

export const UsersSummaryStorage = types
  .compose(UsersStorageModel, UsersSummaryModel)
  .named("UsersSummaryStorage")
  .actions((self) => {
    return {
      setUserRoleOptions(userRoles: Role[]) {
        const userRolesOptions = userRoles.map((role) => {
          return {
            label: role.translationKey,
            value: role.id.toString(),
          };
        });
        self.userRoleOptions = cast(userRolesOptions);
      },

      getTableColumns(): Column[] {
        return [
          {
            key: "name",
            name: "general.user-name",
            type: ColumnType.String,
            sortable: true,
            filterable: true,
            flex: 2,
          },
          {
            key: "role",
            name: "general.users.list-header.role",
            type: ColumnType.SingleSelect,
            valueOptions: self.userRoleOptions,
            sortable: true,
            filterable: true,
          },
          {
            key: "openJobs",
            name: "general.users.list-header.open-jobs",
            type: ColumnType.Number,
            sortable: true,
            filterable: true,
          },
        ];
      },
    };
  })
  .views((self) => ({
    get columns() {
      return self.getTableColumns();
    },
    get canLoadItems() {
      return !!self.filterData.contextFilter;
    },
  }));
